import React from "react";
import DefaultLayout from "app/layouts/DefaultLayout";
import Salon from "app/components/Salon";
import MainMenuItem from "app/components/MainMenuItem";
import BackBtn from "../../../components/BackButton";
import Path from "app/route/Path";

function SalonHomePage() {
  return (
    <DefaultLayout
      headerProps={{
        headerClassName: "md:!block",
        // pageTitle: "ホーム",
      }}
    >
      <Salon.MenuGrid>
        <div className="flex items-center justify-center aspect-square w-full h-full p-[10%]">
          {<MainMenuItem.Salon.Manage.Create />}
        </div>
        <div className="flex items-center justify-center aspect-square w-full h-full p-[10%]">
          {<MainMenuItem.Salon.Manage.Detail />}
        </div>
        <div className="flex items-center justify-center aspect-square w-full h-full p-[10%]">
          {<MainMenuItem.Salon.Manage.Contact />}
        </div>
        <div className="flex items-center justify-center aspect-square w-full h-full p-[10%]">
          {<MainMenuItem.Salon.Manage.CreateNotice />}
        </div>
      </Salon.MenuGrid>
      <BackBtn url={Path.home}/>
    </DefaultLayout>
  );
}

export default SalonHomePage;
